import { ApiPathParam } from '../../../../../models/SearchParamSchema';
import { formAPIPageable } from '../../../../../utils/StringUtils';

export const GET_CANDIDATE_TYPES = '/candidate-types';
export const GET_NATIONAL_EXAM_LEVELS = '/national-exam-levels';

export const POST_RESULTS_APPEAL_EXPORT_EXCEL = `/admin/result-appeals/report`;
export const POST_RAW_RESULTS_APPEAL_SEARCH = (params: ApiPathParam) => {
  const tparams = formAPIPageable(params);
  return `/admin/result-appeals/search${tparams}`;
};

export const GET_RESULTS_APPEAL_DETAIL = '/admin/result-appeals';
